export default __webpack_public_path__ + "static/media/image_beanterra.f3effe93.png";